import {useTransition} from '@logistics-frontend/blocks'
import {ServerError} from '@logistics-frontend/core/utils/network'
import {useCallback} from 'react'

import {fetchCardBound} from '../api'
import {Empty, V1ClientEmployeeCardBoundRequest} from '../types'
import {useConfigContext} from '../ui'

type Options = {
  onSuccess?: (payload: Empty) => void
  onError?: (error: ServerError) => void
}

export function useFetchBoundCard() {
  const {clientId = '', country, makeUrl} = useConfigContext()
  const [{payload, isPending, error}, startTransition] = useTransition<Empty, ServerError>(undefined, {
    key: 'fetch-bound-card',
  })

  const fetchBoundCardHandler = useCallback(
    (body: V1ClientEmployeeCardBoundRequest, options?: Options) => {
      startTransition(
        () => {
          return fetchCardBound(clientId, body, country, makeUrl)
        },
        {
          onCommit(payload) {
            options?.onSuccess?.(payload)
          },
          onError(error) {
            options?.onError?.(error)
          },
        },
      )
    },
    [clientId, country, makeUrl],
  )

  return {
    fetchBoundCardHandler,
    boundCardPayload: payload,
    isBoundCardPending: isPending,
    boundCardError: error,
  }
}
